import { IButtonStyles, ISpinnerStyles, IStackItemStyles, ITheme } from '@fluentui/react';
import { SourceApps } from '../../../models/constants/constants';
import { IThemedProp } from './themesUI';

export interface IContactSupportButtonStyles {
    sourceApp: SourceApps;
    isTeams: boolean;
}

export interface IFooterStyles {
    spinner: ISpinnerStyles;
}

export const getContactSupportButtonStyles = (props: IThemedProp & IContactSupportButtonStyles) => {
    const { theme, sourceApp, isTeams } = props;
    return {
        root: {
            selectors: {
                '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
                    color: 'window !important',
                    backgroundColor: 'windowtext !important',
                    borderColor: 'windowtext !important',
                    forcedColorAdjust: 'none',
                },
            },
            border: '1px solid',
            borderRadius: (sourceApp !== SourceApps.SurfaceApp && sourceApp !== SourceApps.SurfaceApp2) ? '0' : '3px !important',
            borderColor: `${theme.palette.themeTertiary} !important`,
            marginLeft: (sourceApp !== SourceApps.SurfaceApp && sourceApp !== SourceApps.SurfaceApp2) ? '0' : '20px',
            marginRight: '10px',
            float: isTeams ? 'right' : 'left',
            fontFamily: 'inherit',
        },
        rootDisabled: {
            selectors: {
                '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
                    color: 'graytext !important',
                    backgroundColor: 'window !important',
                    borderColor: 'graytext !important',
                    forcedColorAdjust: 'none',
                },
            },
            pointerEvents: 'none',
            cursor: 'not-allowed',
            filter: 'alpha(opacity=65)',
            boxShadow: 'none',
            opacity: '.65',
        },
        rootHovered: {
            selectors: {
                '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
                    color: 'window !important',
                    backgroundColor: 'highlight !important',
                    borderColor: 'highlight !important',
                },
            },
            borderColor: `${theme.palette.themeDark} !important`,
        },
        rootFocused: {
            selectors: {
                '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
                    backgroundColor: 'windowtext !important',
                },
            },
            backgroundColor: `${theme.palette.themeDark} !important`,
            borderColor: `${theme.palette.blueDark} !important`,
            outline: '5px auto -webkit-focus-ring-color',
            outlineOffset: '-2px',
            textDecoration: 'none',
        },
        rootPressed: {
            selectors: {
                '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
                    backgroundColor: 'windowtext !important',
                },
            },
            borderColor: `${theme.palette.themeDark} !important`,
            outline: '5px auto -webkit-focus-ring-color',
            outlineOffset: '-2px',
            textDecoration: 'none',
        },
        label: {
            fontWeight: '400',
            fontSize: '14px',
        },
        spinner: {
            root: {
                display: 'inline',
            },
            circle: {
                float: sourceApp === SourceApps.Teams || sourceApp === SourceApps.Teams2 ? 'right' : 'left',
                marginRight: '10px',
                marginTop: '8px',
            },
        },
    };
};

export const getGetHelpStickyFooterContainerStackStyles = (theme: ITheme): IStackItemStyles => ({
  root: {
    position: 'sticky',
    bottom: '0px',
    left: '0px',
    width: '100%',
    background: theme.palette.neutralLighterAlt,
    zIndex: 10,
    boxShadow: '0px -2px 2px rgba(0, 0, 0, 0.108)',
  },
});

export const getHelpStickyFooterContentStackStyles: IStackItemStyles = {
  root: {
    margin: 'auto',
    padding: '14px 48px',
    width: '100%',
    maxWidth: '696px',
    alignItems: 'center',
  },
};

export const getHelpFooterButtonStyles: IButtonStyles = { root: { borderRadius: '4px' }, label: { fontWeight: 400 } };
